import { FlexProps, Highlight } from '@chakra-ui/react';
import { memo } from 'react';

import { TextCell } from '../TextCell';

interface Props extends FlexProps {
  children: string;
  query: string;
}

export const HighlightCell: React.FC<Props> = memo(
  ({ children, query, ...props }) => (
    <TextCell {...props}>
      <Highlight
        query={query.endsWith('*') ? query.slice(0, -1) : query}
        styles={{ fontWeight: 'medium' }}
      >
        {children}
      </Highlight>
    </TextCell>
  ),
);
